var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.60084 7.28027C2.07075 7.28027 2.45168 7.66843 2.45168 8.14725C2.45168 9.33704 3.30289 10.1702 4.20063 10.1702C5.09837 10.1702 5.94958 9.33704 5.94958 8.14725C5.94958 7.66843 6.33051 7.28027 6.80042 7.28027C7.27033 7.28027 7.65126 7.66843 7.65126 8.14725C7.65126 10.1496 6.17454 11.9041 4.20063 11.9041C2.22673 11.9041 0.75 10.1496 0.75 8.14725C0.75 7.66843 1.13093 7.28027 1.60084 7.28027Z",
    fill: "#808080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.8003 7.28027C7.27021 7.28027 7.65114 7.66843 7.65114 8.14725C7.65114 9.33704 8.50235 10.1702 9.40009 10.1702C10.2978 10.1702 11.149 9.33704 11.149 8.14725C11.149 7.66843 11.53 7.28027 11.9999 7.28027C12.4698 7.28027 12.8507 7.66843 12.8507 8.14725C12.8507 10.1496 11.374 11.9041 9.40009 11.9041C7.42619 11.9041 5.94946 10.1496 5.94946 8.14725C5.94946 7.66843 6.3304 7.28027 6.8003 7.28027Z",
    fill: "#808080"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 7.28027C12.47 7.28027 12.851 7.66843 12.851 8.14725C12.851 9.33704 13.7022 10.1702 14.5999 10.1702C15.4977 10.1702 16.3489 9.33704 16.3489 8.14725C16.3489 7.66843 16.7298 7.28027 17.1997 7.28027C17.6696 7.28027 18.0506 7.66843 18.0506 8.14725C18.0506 10.1496 16.5738 11.9041 14.5999 11.9041C12.626 11.9041 11.1493 10.1496 11.1493 8.14725C11.1493 7.66843 11.5302 7.28027 12.0001 7.28027Z",
    fill: "#808080"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1996 7.28027C17.6695 7.28027 18.0504 7.66843 18.0504 8.14725C18.0504 9.33704 18.9016 10.1702 19.7994 10.1702C20.6971 10.1702 21.5483 9.33704 21.5483 8.14725C21.5483 7.66843 21.9293 7.28027 22.3992 7.28027C22.8691 7.28027 23.25 7.66843 23.25 8.14725C23.25 10.1496 21.7733 11.9041 19.7994 11.9041C17.8255 11.9041 16.3488 10.1496 16.3488 8.14725C16.3488 7.66843 16.7297 7.28027 17.1996 7.28027Z",
    fill: "#808080"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.34243 11.0371V20.1885C4.34243 20.5077 4.59638 20.7665 4.90965 20.7665H19.0903C19.4036 20.7665 19.6576 20.5077 19.6576 20.1885V11.0371H21.3592V20.1885C21.3592 21.4653 20.3434 22.5004 19.0903 22.5004H4.90965C3.65657 22.5004 2.64075 21.4653 2.64075 20.1885V11.0371H4.34243Z",
    fill: "#808080"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.596 8.43359L19.9431 3.62139C19.8634 3.38957 19.6487 3.23434 19.4077 3.23434L4.59214 3.23434C4.3511 3.23434 4.13638 3.38957 4.05676 3.62139L2.40383 8.43359L0.79768 7.86078L2.45061 3.04858C2.76912 2.1213 3.62798 1.5004 4.59214 1.5004L19.4077 1.5004C20.3718 1.5004 21.2307 2.1213 21.5492 3.04858L23.2021 7.86078L21.596 8.43359Z",
    fill: "#808080"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0399 21.6328L13.0399 17.298C13.0399 16.9787 12.7859 16.72 12.4727 16.72L11.5273 16.72C11.214 16.72 10.9601 16.9787 10.9601 17.298L10.9601 21.6328L9.25838 21.6328L9.25838 17.298C9.25838 16.0211 10.2742 14.986 11.5273 14.986L12.4727 14.986C13.7258 14.986 14.7416 16.0211 14.7416 17.298L14.7416 21.6328L13.0399 21.6328Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.2f09a85276c4a1966394d11aa8bd313c.svg";
export { ForwardRef as ReactComponent };